import * as React from "react"

/**
 * Returns true if the primary pointing device is coarse (finger/stylus).
 * Uses the CSS `pointer: coarse` media query which is the most reliable
 * cross-browser signal for touch-primary devices (phones, tablets, stylus PCs).
 */
export function useIsTouch() {
  const [isTouch, setIsTouch] = React.useState<boolean>(() => {
    if (typeof window === "undefined") return false
    return window.matchMedia("(pointer: coarse)").matches
  })

  React.useEffect(() => {
    const mql = window.matchMedia("(pointer: coarse)")
    const onChange = (e: MediaQueryListEvent) => setIsTouch(e.matches)
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isTouch
}
